"use client";

import Link from "next/link";
import { useCallback, useEffect, useId, useState } from "react";

import styles from "./siteChrome.module.css";

const MENU_LINKS = [
  { href: "/", label: "Accueil" },
  { href: "/#fonctionnalites", label: "Fonctionnalités" },
  { href: "/#tarifs", label: "Tarifs" },
  { href: "/download", label: "Télécharger" },
] as const;

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const titleId = useId();

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    if (!menuOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [menuOpen]);

  return (
    <>
      <header className={styles.topbar}>
        <div className={styles.brand}>
          <button
            type="button"
            className={styles.menuToggle}
            aria-label="Ouvrir le menu"
            aria-expanded={menuOpen}
            aria-controls="site-mobile-menu"
            onClick={() => setMenuOpen(true)}
          >
            <i className="bi bi-list" aria-hidden="true" />
          </button>

          <span className={styles.brandMark} aria-hidden="true">
            P
          </span>

          <div>
            <div className={styles.brandName}>Pharmapp</div>
            <div className={styles.brandSub}>Portail web</div>
          </div>
        </div>

        <nav className={styles.nav} aria-label="Navigation principale">
          {MENU_LINKS.map((item) => (
            <Link key={item.href} href={item.href}>
              {item.label}
            </Link>
          ))}
          <Link href="/purchase" className={styles.navCta}>
            Commencer maintenant
          </Link>
        </nav>
      </header>

      {menuOpen ? (
        <div
          id="site-mobile-menu"
          className={styles.mobileOverlay}
          role="dialog"
          aria-modal="true"
          aria-labelledby={titleId}
        >
          <span id={titleId} className={styles.srOnly}>
            Menu
          </span>
          <button type="button" className={styles.mobileOverlayClose} aria-label="Fermer le menu" onClick={closeMenu}>
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>

          <nav className={styles.mobileNav} aria-label="Navigation principale (mobile)">
            {MENU_LINKS.map((item) => (
              <Link key={item.href} href={item.href} className={styles.mobileNavItem} onClick={closeMenu}>
                {item.label}
              </Link>
            ))}
            <Link href="/purchase" className={`${styles.mobileNavItem} ${styles.mobileNavCta}`} onClick={closeMenu}>
              Commencer maintenant
            </Link>
          </nav>
        </div>
      ) : null}
    </>
  );
}
